"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.slurpFile = void 0;
const fs_1 = require("fs");
const { readFile } = fs_1.promises;
const fileStatusHash = {};
const slurpFile = (path) => new Promise((resolve, reject) => {
    if (!fileStatusHash[path]) {
        fileStatusHash[path] = { isReading: true, contents: "", requestQueue: [] };
        fileStatusHash[path].requestQueue.push({ resolve, reject });
        readFile(path, "utf8")
            .then((data) => {
            fileStatusHash[path].isReading = false;
            fileStatusHash[path].contents = data;
            const { requestQueue } = fileStatusHash[path];
            while (requestQueue.length) {
                const { resolve } = requestQueue.pop();
                resolve(data);
            }
        })
            .catch((err) => {
            fileStatusHash[path].isReading = false;
            const { requestQueue } = fileStatusHash[path];
            while (requestQueue.length) {
                const { reject } = requestQueue.pop();
                reject(err);
            }
        });
    }
    else if (fileStatusHash[path].isReading) {
        fileStatusHash[path].requestQueue.push({ resolve, reject });
    }
    else {
        resolve(fileStatusHash[path].contents);
    }
});
exports.slurpFile = slurpFile;
